import "./LabReportDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import LabReportDetailsViewComponent from "./lab-report-details-view/LabReportDetailsViewComponent";
import LabReportDetailsEditComponent from "./lab-report-details-edit/LabReportDetailsEditComponent";

interface LabReportDetailsViewEditComponentProps {
    labDetails: any;
    onUpdateLabReportDetails: Function;
    onModeChange: any;
    canEdit: boolean;
}

const LabReportDetailsViewEditComponent = (props: LabReportDetailsViewEditComponentProps) => {
    const {labDetails, onUpdateLabReportDetails, onModeChange, canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [tempLabDetails, setTempLabDetails] = useState<any>(labDetails);

    const handleLabReportSetupChange = useCallback((logo: any,themeColor:any) => {
        console.log(themeColor)
        onUpdateLabReportDetails(logo,themeColor);
        setMode("view");
    }, [onUpdateLabReportDetails]);

    const handleLabDirectorDetailsEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (labDetails) {
            setTempLabDetails(labDetails);
        }
    }, [labDetails]);

    useEffect(() => {
        onModeChange(mode)
    }, [mode, onModeChange])

    return (
        <div className={'lab-report-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <LabReportDetailsViewComponent
                    labDetails={tempLabDetails}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" && <LabReportDetailsEditComponent
                    labDetails={tempLabDetails}
                    onUpdateComplete={handleLabReportSetupChange}
                    onEditCancel={handleLabDirectorDetailsEditCancel}
                />
            }
        </div>
    );

};

export default LabReportDetailsViewEditComponent;
